import React from 'react'
import { EmptyState } from '@components/ui'
import './EmptyTreatmentPlan.css'

const DEFAULT_ACTION_LABEL = 'Add plan'

interface EmptyTreatmentPlanProps {
  title?: string
  description?: string
  actionLabel?: string
  onCreateNewPlan?: () => void
}

const EmptyTreatmentPlan: React.FC<EmptyTreatmentPlanProps> = ({
  title = 'No treatment plans found',
  description = "You don't have any treatment plans on record yet.",
  actionLabel = DEFAULT_ACTION_LABEL,
  onCreateNewPlan,
}): React.ReactElement => {
  return (
    <EmptyState
      className="empty-treatment-plan"
      iconClass="mgc mgc_document_fill"
      title={title}
      description={description}
      actionLabel={onCreateNewPlan ? actionLabel : undefined}
      onAction={onCreateNewPlan}
    />
  )
}

export default EmptyTreatmentPlan
